/** MuchFi's DogeOS Chikyu deployment. Never used on Base or mainnet. */
export const MUCHFI_CHIKYU = {
  chainId: 6281971,
  router: "0xC653e745FC613a03D156DACB924AE8e9148B18dc",
  wrappedNative: "0xF6BDB158A5ddF77F1B83bC9074F6a472c58D78aE",
  usdc: "0xD19d2Ffb1c284668b7AFe72cddae1BAF3Bc03925",
  // This is MuchFi's test token, NOT the six-decimal Base USDC contract.
  usdcDecimals: 18,
} as const;
